<script setup lang="ts">
import { useField } from 'vee-validate';
import { toRef } from 'vue';

import BeamQualities from './BeamQualities.vue';

const props = defineProps<{
  name: string; // taskItemAreas[{areaIndex}].medicalSystemSetup.beamQualityContainer`
}>();

const { validate, errorMessage } = useField(toRef(() => props.name));
</script>
<template>
  <v-alert v-if="errorMessage" type="error" variant="tonal" class="text-body-1 text-center mb-2">
    <template #text>
      {{ errorMessage }}
    </template>
  </v-alert>

  <!-- Photon -->
  <BeamQualities
    :name="`${name}.beamQualitiesPhoton`"
    class="container-level-3"
    beamQualityType="NominalPhotonBeamEnergy"
    @select="validate()"
  />

  <!-- Electron -->
  <BeamQualities
    :name="`${name}.beamQualitiesElectron`"
    class="container-level-3 mt-8"
    beamQualityType="NominalElectronBeamEnergy"
    @select="validate()"
  />
</template>
